import { render, staticRenderFns } from "./ExamenCompleto.vue?vue&type=template&id=2a484324&"
import script from "./ExamenCompleto.vue?vue&type=script&lang=js&"
export * from "./ExamenCompleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports